import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { redirectToClientOverview } from "@/core/lib/feature-guards";
import { hasInputProcessTab } from "@/features/project/lib/project-tabs";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/classifications/editor",
)({
  validateSearch: z.object({
    classificationTab: z
      .enum(["journals", "ledgers"])
      .catch("ledgers")
      .default("ledgers"),
    classificationTemplateId: z.string().optional(),
  }),
  beforeLoad: ({ context: { active, appInfo }, params }) => {
    if (
      !hasInputProcessTab({
        module: "audit",
        features: active.features,
        appCapabilities: appInfo ?? { document_intelligence: false },
        classificationTemplateIds: active.classification_template_ids,
      })
    ) {
      redirectToClientOverview(params.id);
    }
  },
});
